<template>
    <div class="equipment-notes-modal">
        <JsonEditorVue
            v-model="notes"
            :stringified="false"
            mode="text"
            class="json-editor mb-5"
        />

        <CoreButton
            label="§ui_button.update"
            icon="pi-save"
            @click="update"
        />
    </div>
</template>

<script>
import JsonEditorVue from 'json-editor-vue'
import { useUnitStore } from '@/stores/unit'
import { useModalStore } from '@/stores/modal'
import CoreButton from '@/components/core/CoreButton.vue'

export default {
    name: 'EquipmentNotesModal',

    components: {
        JsonEditorVue,
        CoreButton,
    },

    data() {
        return {
            unitStore: useUnitStore(),
            modalStore: useModalStore(),

            notes: '',
        }
    },

    mounted() {
        this.setData()
    },

    methods: {
        setData() {
            this.notes = JSON.parse(this.unitStore.unitData.notes)
        },

        update() {
            this.unitStore.unitData.notes = JSON.stringify(this.notes)
            this.modalStore.setClose()
        },
    },
}
</script>

<style>
.equipment-notes-modal {
    .json-editor {
        & .jse-json-node.jse-root.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,
        .jse-main.svelte-ybuk0j {
            min-height: 500px;
        }
    }
}
</style>
